<template>
  <fb-form-properties-manager id="html-v1-properties-qavivd" :fields="fields" :formId="formId" />
</template>

<script>
export default {
  name: "HtmlV1Properties",
  props: ["formId"],
  data() {
    return {
      fields: [
        {
          type: "textarea",
          properties: {
            label: "Html"
          },
          property: "value"
        },
        {
          type: "conditionEditor",
          properties: {
            label: "Visibility condition",
            updateValueMiddleware: (value) => {return value.replace("{{(","{{!(")}
          },
          property: "hidden"   
        }
      ]
    };
  }
};
</script>

<style></style>
